import {Keypair} from "@solana/web3.js"
import OpenLogin, {OPENLOGIN_NETWORK_TYPE} from "@toruslabs/openlogin"
import {getED25519Key} from "@toruslabs/openlogin-ed25519"
import forge from "node-forge"
import {AppConfig} from "../App.config"
import {IPFSKeys, Ed25519Keypair} from "../interfaces/keys"

export const initOpenLogin = async (): Promise<OpenLogin> => {
  const openLogin = new OpenLogin({
    clientId: AppConfig.openLoginClientId,
    network: AppConfig.openLoginNetwork as OPENLOGIN_NETWORK_TYPE,
  })
  await openLogin.init()
  return openLogin
}

export const getWeb3AuthKeypair = async (): Promise<Keypair | null> => {
  const openLogin = await initOpenLogin()
  const privateKey = openLogin.privKey
  if (!privateKey) {
    return null
  }
  const {sk} = getED25519Key(privateKey)
  return Keypair.fromSecretKey(sk)
}

export const getHashedSeed = (seed: string): string => {
  const hash = forge.md.sha256.create()
  hash.update(seed)
  return hash.digest().toHex()
}

export const getHashedEd25519Keypair = async (seed: string): Promise<IPFSKeys> => {
  // Get hash for web
  let md = forge.md.sha256.create()
  md.update(`${seed}web`)
  const webHash = md.digest().toHex()

  // Hash
  md = forge.md.sha256.create()
  md.update(`${seed}desktop`)
  const desktopHash = md.digest().toHex()

  // Convert to ED25519 key
  const ed25519 = forge.pki.ed25519
  return {
    webKeypair: ed25519.generateKeyPair({seed: Buffer.from(webHash)}),
    desktopKeypair: ed25519.generateKeyPair({seed: Buffer.from(desktopHash)})
  }
}

export const convertEd25519ToIPFSKey = (keypair: Ed25519Keypair): string => {
  const privateKeyArr = new Uint8Array(keypair.privateKey)

  // The prefix is required by IPFS
  const prefixArr = new Uint8Array([8, 1, 18, 64])
  const concatArr = new Uint8Array([...prefixArr, ...privateKeyArr])

  return Buffer.from(concatArr).toString("base64")
}
